import React from "react";
import styled from "styled-components";
import { Field } from "formik";
import InputMoment from "input-moment";
import "input-moment/dist/input-moment.css";
import { colors } from "core/stylesheet";
import * as model from "modules/booking/model";

const Wrap = styled.div`
  .m-input-moment .options button.is-active,
  .m-calendar tbody td:hover,
  .m-time .time,
  .u-slider-time .value,
  .m-calendar .toolbar button {
    background-color: ${colors.brand};
  }
  .m-input-moment .options button,
  .m-calendar .toolbar button,
  .u-slider-time .handle:after,
  .m-calendar tbody td:hover {
    border-color: ${colors.brand};
  }
  .m-calendar .toolbar .current-date,
  .m-calendar thead td,
  .m-input-moment .options button:not(.is-active),
  .m-time .separater,
  .m-time .time-text,
  .m-calendar .current-day {
    color: ${colors.brand};
  }
  .m-calendar tbody td:hover {
    color: #fff;
  }
  button.prev-month:before,
  button.next-month:before {
    font-family: "Material Icons";
  }
  button.prev-month:before {
    content: "keyboard_arrow_left";
  }
  button.next-month:before {
    content: "keyboard_arrow_right";
  }
`;

const Date = styled.div`
  max-width: 330px;
  width: 100%;
`;

export default props => (
  <Field
    name={props.name}
    render={({ field, form: { setValues, values } }) => (
      <Wrap>
        <Date className="bg-white pv1 ph2 br1 ba b--black-10 f7 mb2">
          {model.formatTime(field.value)}
        </Date>
        <InputMoment
          moment={field.value}
          onChange={m =>
            setValues({
              ...values,
              [field.name]: m
            })
          }
          minStep={15}
          hourStep={1}
        />
      </Wrap>
    )}
  />
);



// WEBPACK FOOTER //
// ./src/components/generic/form/formik/Calendar/index.js